// extracted by mini-css-extract-plugin
export default {"modalContent":"EditorModal_modalContent__kmNkK","title":"EditorModal_title__EHKW6","content":"EditorModal_content__LBlts","buttons":"EditorModal_buttons__qBwmj"};